import * as React from 'react';

export const Overlay = (props: {
  style?: any;
  onClick?: () => void;
}) => {

  return <div
    style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 100,
      background: 'rgba(0,0,0,0)',
      ...props.style
    }}
    onClick={props.onClick}
  ></div>;
};
